module.exports = "/images/vendor/trumbowyg/dist/ui/icons.svg?f7eb750e8b2366478e311bd9e15e6f2c";